/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type TVShowStateType = "archive" | "available" | "deleted" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type TVShowApp_viewer$ref: FragmentReference;
export type TVShowApp_viewer = {|
  +tvshows: ?{|
    +totalCount: ?number,
    +tvShows: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +categoryName: ?string,
      +order: number,
      +isProject: ?boolean,
      +state: TVShowStateType,
    |}>,
  |},
  +$refType: TVShowApp_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "TVShowApp_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "isProject",
      "type": "Boolean",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "states",
      "type": "[String]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "tvshows",
      "name": "tvshowsPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isProject",
          "variableName": "isProject",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page",
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "pageSize",
          "value": 100,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "states",
          "variableName": "states",
          "type": "[String]"
        }
      ],
      "concreteType": "TVShowsPagination",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tvShows",
          "storageKey": null,
          "args": null,
          "concreteType": "TVShow",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "order",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isProject",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "state",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'db7c71abe8e239c0e0ee1facf8569046';
module.exports = node;



// WEBPACK FOOTER //
// src/components/tvshow/__generated__/TVShowApp_viewer.graphql.js